// route page
import Vue from 'vue'
import Router from 'vue-router'
import AuthLayout from '@/layouts/Auth'
import AppLayout from '@/layouts/App'
import PublicLayout from '@/layouts/Public'
import store from '@/store'

Vue.use(Router)

function getUserRole () {
  return new Promise(function(resolve, reject) {
    if (store.state.user.user) {
      let userRole = store.state.user.user.role
      resolve(userRole)
    } else {
      reject(new Error('You have no role assigned!'))
    }
  })
}

const router = new Router({
  base: process.env.BASE_URL,
  mode: 'history',
  routes: [
    {
      path: '/',
      component: AuthLayout,
      redirect: '/login',
    },
    // Superadmin routes
    {
      path: '/superadmin',
      redirect: '/superadmin/dashboard',
      component: AppLayout,
      meta: { authRequired: true, roles: ['superadmin'], hidden: true },
      children: [
        // Dashboards
        {
          name: 'sudashboard',
          path: '/superadmin/dashboard',
          meta: {
            title: 'Dashboard',
          },
          component: () => import('./views/superadmin/dashboard'),
        },
        {
          path: '/dashboard/analytics',
          meta: {
            title: 'Dashboard Analytics',
          },
          component: () => import('./views/dashboard/analytics'),
        },
        {
          path: '/dashboard/statistics',
          meta: {
            title: 'Dashboard Statistics',
          },
          component: () => import('./views/dashboard/statistics'),
        },
        {
          path: '/dashboard/ecommerce',
          meta: {
            title: 'Dashboard Ecommerce',
          },
          component: () => import('./views/dashboard/ecommerce'),
        },
        {
          path: '/dashboard/crypto',
          meta: {
            title: 'Dashboard Crypto',
          },
          component: () => import('./views/dashboard/crypto'),
        },
        {
          path: '/dashboard/jira',
          meta: {
            title: 'Dashboard Jira',
          },
          component: () => import('./views/dashboard/jira'),
        },
        {
          path: '/dashboard/helpdesk',
          meta: {
            title: 'Dashboard Helpdesk',
          },
          component: () => import('./views/dashboard/helpdesk'),
        },

        // Plans
        {
          name: 'plans',
          path: '/superadmin/plans',
          meta: {
            title: 'Plans',
          },
          component: () => import('./views/superadmin/plan'),
        },
        // Boards
        {
          name: 'boards',
          path: '/superadmin/boards',
          meta: {
            title: 'Boards',
          },
          component: () => import('./views/superadmin/board'),
        },
        // Schools
        {
          name: 'schools',
          path: '/superadmin/schools',
          meta: {
            title: 'Schools',
          },
          component: () => import('./views/superadmin/school'),
        },
        {
          name: 'schoolmanage',
          path: '/superadmin/schools/manage/:id',
          meta: {
            title: 'Manage School',
          },
          component: () => import('./views/superadmin/schoolmanage'),
        },
        // Ecommerce
        {
          path: '/ecommerce/dashboard',
          meta: {
            title: 'Ecommerce Dashboard',
          },
          component: () => import('./views/ecommerce/dashboard'),
        },
        {
          path: '/ecommerce/orders',
          meta: {
            title: 'Ecommerce Orders',
          },
          component: () => import('./views/ecommerce/orders'),
        },
        {
          path: '/ecommerce/product-catalog',
          meta: {
            title: 'Ecommerce Product Catalog',
          },
          component: () => import('./views/ecommerce/product-catalog'),
        },
        {
          path: '/ecommerce/product-details',
          meta: {
            title: 'Ecommerce Product Details',
          },
          component: () => import('./views/ecommerce/product-details'),
        },
        {
          path: '/ecommerce/cart',
          meta: {
            title: 'Ecommerce Cart',
          },
          component: () => import('./views/ecommerce/cart'),
        },
        // Apps
        {
          path: '/apps/messaging',
          meta: {
            title: 'Apps Messaging',
          },
          component: () => import('./views/apps/messaging'),
        },
        {
          path: '/apps/calendar',
          meta: {
            title: 'Apps Calendar',
          },
          component: () => import('./views/apps/calendar'),
        },
        {
          path: '/apps/mail',
          meta: {
            title: 'Apps Mail',
          },
          component: () => import('./views/apps/mail'),
        },
        {
          path: '/apps/profile',
          meta: {
            title: 'Apps Profile',
          },
          component: () => import('./views/apps/profile'),
        },
        {
          path: '/apps/gallery',
          meta: {
            title: 'Apps Gallery',
          },
          component: () => import('./views/apps/gallery'),
        },
        // Extra Apps
        {
          path: '/extra-apps/github-explore',
          meta: {
            title: 'Github Explore',
          },
          component: () => import('./views/extra-apps/github-explore'),
        },
        {
          path: '/extra-apps/github-discuss',
          meta: {
            title: 'Github Discuss',
          },
          component: () => import('./views/extra-apps/github-discuss'),
        },
        {
          path: '/extra-apps/digitalocean-droplets',
          meta: {
            title: 'DigitalOcean Droplets',
          },
          component: () => import('./views/extra-apps/digitalocean-droplets'),
        },
        {
          path: '/extra-apps/digitalocean-create',
          meta: {
            title: 'DigitalOcean Create Droplets',
          },
          component: () => import('./views/extra-apps/digitalocean-create'),
        },
        {
          path: '/extra-apps/google-analytics',
          meta: {
            title: 'Google Analytics',
          },
          component: () => import('./views/extra-apps/google-analytics'),
        },
        {
          path: '/extra-apps/wordpress-post',
          meta: {
            title: 'Wordpress Post',
          },
          component: () => import('./views/extra-apps/wordpress-post'),
        },
        {
          path: '/extra-apps/wordpress-posts',
          meta: {
            title: 'Wordpress Posts',
          },
          component: () => import('./views/extra-apps/wordpress-posts'),
        },
        {
          path: '/extra-apps/wordpress-add',
          meta: {
            title: 'Wordpress Add',
          },
          component: () => import('./views/extra-apps/wordpress-add'),
        },
        {
          path: '/extra-apps/todoist-list',
          meta: {
            title: 'Todoist List',
          },
          component: () => import('./views/extra-apps/todoist-list'),
        },
        {
          path: '/extra-apps/jira-dashboard',
          meta: {
            title: 'Jira Dashboard',
          },
          component: () => import('./views/extra-apps/jira-dashboard'),
        },
        {
          path: '/extra-apps/jira-agile-board',
          meta: {
            title: 'Jira Agile Board',
          },
          component: () => import('./views/extra-apps/jira-agile-board'),
        },
        {
          path: '/extra-apps/helpdesk-dashboard',
          meta: {
            title: 'Helpdesk Dashboard',
          },
          component: () => import('./views/extra-apps/helpdesk-dashboard'),
        },
        // Widgets
        {
          path: '/widgets/general',
          meta: {
            title: 'Widgets General',
          },
          component: () => import('./views/widgets/general'),
        },
        {
          path: '/widgets/lists',
          meta: {
            title: 'Widgets Lists',
          },
          component: () => import('./views/widgets/lists'),
        },
        {
          path: '/widgets/tables',
          meta: {
            title: 'Widgets Tables',
          },
          component: () => import('./views/widgets/tables'),
        },
        {
          path: '/widgets/charts',
          meta: {
            title: 'Widgets Charts',
          },
          component: () => import('./views/widgets/charts'),
        },
        // Cards
        {
          path: '/cards/basic-cards',
          meta: {
            title: 'Basic Cards',
          },
          component: () => import('./views/cards/basic-cards'),
        },
        {
          path: '/cards/tabbed-cards',
          meta: {
            title: 'Tabbed Cards',
          },
          component: () => import('./views/cards/tabbed-cards'),
        },
        // UI Kits
        {
          path: '/ui-kits/bootstrap',
          meta: {
            title: 'Bootstrap',
          },
          component: () => import('./views/ui-kits/bootstrap'),
        },
        {
          path: '/ui-kits/antd',
          meta: {
            title: 'Ant Design',
          },
          component: () => import('./views/ui-kits/antd'),
        },
        // Tables
        {
          path: '/tables/bootstrap',
          meta: {
            title: 'Bootstrap Tables',
          },
          component: () => import('./views/tables/bootstrap'),
        },
        {
          path: '/tables/antd',
          meta: {
            title: 'Ant Design Tables',
          },
          component: () => import('./views/tables/antd'),
        },
        // Charts
        {
          path: '/charts/chartistjs',
          meta: {
            title: 'Chartist.js',
          },
          component: () => import('./views/charts/chartistjs'),
        },
        {
          path: '/charts/chartjs',
          meta: {
            title: 'Chart.js',
          },
          component: () => import('./views/charts/chartjs'),
        },
        {
          path: '/charts/c3',
          meta: {
            title: 'C3 Charts',
          },
          component: () => import('./views/charts/c3'),
        },
        {
          path: '/charts/peity',
          meta: {
            title: 'Peity',
          },
          component: () => import('./views/charts/peity'),
        },
        // Icons
        {
          path: '/icons/feather-icons',
          meta: {
            title: 'Feather Icons',
          },
          component: () => import('./views/icons/feather-icons'),
        },
        {
          path: '/icons/fontawesome',
          meta: {
            title: 'Fontawesome Icons',
          },
          component: () => import('./views/icons/fontawesome'),
        },
        {
          path: '/icons/linearicons-free',
          meta: {
            title: 'Linearicons Free',
          },
          component: () => import('./views/icons/linearicons-free'),
        },
        {
          path: '/icons/icomoon-free',
          meta: {
            title: 'Icomoon Free',
          },
          component: () => import('./views/icons/icomoon-free'),
        },
        // Advanced
        {
          path: '/advanced/form-examples',
          meta: {
            title: 'Form Examples',
          },
          component: () => import('./views/advanced/form-examples'),
        },
        {
          path: '/advanced/email-templates',
          meta: {
            title: 'Email Templates',
          },
          component: () => import('./views/advanced/email-templates'),
        },
        {
          path: '/advanced/utilities',
          meta: {
            title: 'Utilities',
          },
          component: () => import('./views/advanced/utilities'),
        },
        {
          path: '/advanced/grid',
          meta: {
            title: 'Grid',
          },
          component: () => import('./views/advanced/grid'),
        },
        {
          path: '/advanced/typography',
          meta: {
            title: 'Typography',
          },
          component: () => import('./views/advanced/typography'),
        },
        {
          path: '/advanced/pricing-tables',
          meta: {
            title: 'Pricing Tables',
          },
          component: () => import('./views/advanced/pricing-tables'),
        },
        {
          path: '/advanced/invoice',
          meta: {
            title: 'Invoice',
          },
          component: () => import('./views/advanced/invoice'),
        },

        // 404
        {
          path: '/404',
          meta: {
            title: 'Error 404',
          },
          component: () => import('./views/system/404'),
        },
      ],
    },

    // Admin routes
    {
      path: '/dashboard',
      redirect: '/dashboard',
      component: AppLayout,
      meta: { authRequired: true, roles: ['admin', 'supervisor', 'staff', 'teacher'], hidden: true },
      children: [
        // Dashboards
        {
          name: 'dashboard',
          path: `/dashboard`,
          meta: {
            title: 'Dashboard',
          },
          component: () => import('./views/admin/dashboard'),
        },
        {
          name: 'managestudents',
          path: '/students',
          meta: {
            title: 'Manage Students',
          },
          component: () => import('./views/admin/student/manage'),
        },
        {
          name: 'schoolnotification',
          path: '/school-notification',
          meta: {
            title: 'School Notification',
          },
          component: () => import('./views/admin/notify'),
        },
        {
          name: 'examresultsend',
          path: '/exam-result-send',
          meta: {
            title: 'Exam Result Send',
          },
          component: () => import('./views/admin/examResultSendNotify'),
        },
        {
          name: 'homework',
          path: '/homework',
          meta: {
            title: 'Homework',
          },
          component: () => import('./views/admin/homework'),
        },
        {
          name: 'studentphotos',
          path: '/student-photos',
          meta: {
            title: 'Student Photos',
          },
          component: () => import('./views/admin/student/studentphoto'),
        },
        {
          name: 'studentreports',
          path: '/student-reports',
          meta: {
            title: 'Student Reports',
          },
          component: () => import('./views/admin/student/report'),
        },
        {
          name: 'studentattendancereport',
          path: '/student-attendance-report',
          meta: {
            title: 'Attendance Report',
          },
          component: () => import('./views/admin/backoffice/attendancereport'),
        },
        {
          name: 'studentattendanceexport',
          path: '/student-attendance-export',
          meta: {
            title: 'Downloads',
          },
          component: () => import('./views/admin/student/export'),
        },

        // Staff Settings
        // Staff Grades
        {
          name: 'staffgrades',
          path: '/staffgrades',
          meta: {
            title: 'Staff Grades',
          },
          component: () => import('./views/admin/staffgrade'),
        },

        // Staff
        {
          name: 'managestaffs',
          path: '/staffs',
          meta: {
            title: 'Staffs',
          },
          component: () => import('./views/admin/staff'),
        },
        {
          name: 'takeattendance',
          path: '/takeattendance',
          meta: {
            title: 'Take Attendance',
          },
          component: () => import('./views/admin/StaffAttendance/Forms/webpunch.vue'),
        },
        {
          name: 'attendancereport',
          path: '/attendancereport',
          meta: {
            title: 'Attendance Report',
          },
          component: () => import('./views/admin/StaffAttendance/Reports'),
        },
        {
          name: 'dailyattendancereport',
          path: '/staffattendance/report/daily/:day',
          meta: {
            title: 'Daily Attendance Report',
          },
          component: () => import('./views/admin/StaffAttendance/Reports/Daily'),
        },
        {
          name: 'monthlyattendancereport',
          path: '/staffattendance/report/monthly/:month',
          meta: {
            title: 'Monthly Attendance Report',
          },
          component: () => import('./views/admin/StaffAttendance/Reports/Monthly'),
        },
        {
          name: 'updatestaffattendance',
          path: '/staffattendance/manage',
          meta: {
            title: 'Bulk update Attendance',
          },
          component: () => import('./views/admin/StaffAttendance/Forms'),
        },
        {
          name: 'updatestaffattendancedaily',
          path: '/staffattendance/update/:day',
          meta: {
            title: 'Update Daily Attendance',
          },
          component: () => import('./views/admin/StaffAttendance/Forms/singleupdate'),
        },
        {
          name: 'updatestaffattendancemonthly',
          path: '/staffattendance/updatebulk/:month',
          meta: {
            title: 'Update Monthly Attendance',
          },
          component: () => import('./views/admin/StaffAttendance/Forms/BulkUpdate'),
        },

        // Academic Settings
        // Promotion
        {
          name: 'promotion',
          path: '/promotion',
          meta: {
            title: 'Promotion',
          },
          component: () => import('./views/admin/promotion'),
        },
        // Sessions
        {
          name: 'sessions',
          path: '/sessions',
          meta: {
            title: 'Sessions',
          },
          component: () => import('./views/admin/session'),
        },
        // Sections
        {
          name: 'sections',
          path: '/sections',
          meta: {
            title: 'Sections',
          },
          component: () => import('./views/admin/section'),
        },
        // Subjects
        {
          name: 'subjects',
          path: '/subjects',
          meta: {
            title: 'Subjects',
          },
          component: () => import('./views/admin/subject'),
        },
        // Internal Assessments
        {
          name: 'internalassessments',
          path: '/internal_assessments',
          meta: {
            title: 'Internal Assessments',
          },
          component: () => import('./views/admin/internal'),
        },
        // School Fees
        {
          name: 'fees',
          path: '/fees',
          meta: {
            title: 'Fees',
          },
          component: () => import('./views/admin/fee'),
        },
        // School classes
        {
          name: 'schoolclasses',
          path: '/classes',
          meta: {
            title: 'Classes',
          },
          component: () => import('./views/admin/schoolclass'),
        },
        // School Class setup
        {
          name: 'classsetup',
          path: '/classsetup',
          meta: {
            title: 'Class Setup',
          },
          component: () => import('./views/admin/classsetup'),
        },
        // Class Section Timetable setup
        {
          name: 'timetables',
          path: '/timetables',
          meta: {
            title: 'Timetables',
          },
          component: () => import('./views/admin/timetable'),
        },

        // bulkReportCard
        {
          name: 'bulkreportcard',
          path: '/bosemexam/bulkreportcard/:classId/:sectionId/examsId/:sessionId/:reportFormat',
          // path: '/bosemexam/bulkreportcard',
          meta: {
            title: 'Bulk Report Card',
          },
          component: () => import('./views/admin/bosemexam/bulkreport'),
        },
        // Final exam Bulk Report Card
        {
          name: 'finalbulkReportCard',
          path: '/bosemexam/finalbulkReportCard/:classId/:sectionId/:sessionId/:reportformat',
          meta: {
            title: 'Exam Types',
          },
          component: () => import('./views/admin/bosemexam/final/BulkFinalReport/index'),
        },

        // Bosem Exam
        {
          name: 'exam_types',
          path: '/bosemexam/types',
          meta: {
            title: 'Exam Types',
          },
          component: () => import('./views/admin/bosemexam/types'),
        },
        // Bosem Exam Manage
        {
          name: 'bosemexammanage',
          path: '/bosemexam/manage/:id',
          meta: {
            title: 'Exam Management',
          },
          component: () => import('./views/admin/bosemexam/manage'),
        },
        // Bosem Admidcard
        {
          name: 'bosemexamadmitcard',
          path: '/bosemexam/admitcards/:id',
          meta: {
            title: 'Exam Admitcards',
          },
          component: () => import('./views/admin/bosemexam/admitcard'),
        },
        {
          name: 'school_exams',
          path: '/bosemexam/schoolexams',
          meta: {
            title: 'School Exams',
          },
          component: () => import('./views/admin/bosemexam/schoolexams'),
        },
        {
          name: 'manage_exams',
          path: '/bosemexam/manages',
          meta: {
            title: 'Manage Exams',
          },
          component: () => import('./views/admin/bosemexam/setup'),
        },
        // exam setting
        {
          name: 'exam_setting',
          path: '/bosemexam/examsetting',
          meta: {
            title: 'Exam Setting',
          },
          component: () => import('./views/admin/bosemexam/examsetting'),
        },
        {
          name: 'exam_manage',
          path: '/bosemexam/manage/:id',
          meta: {
            title: 'Exam Management',
          },
          component: () => import('./views/admin/bosemexam/manage'),
        },

        {
          name: 'exam_admitcard',
          path: '/bosemexam/admitcards/:id',
          meta: {
            title: 'Exam Admitcards',
          },
          component: () => import('./views/admin/bosemexam/admitcard'),
        },
        // exam report
        {
          name: 'report_cards',
          path: '/bosemexam/reportcard',
          meta: {
            title: 'Report Card',
          },
          component: () => import('./views/admin/bosemexam/reportcard/index'),
        },
        // manage final
        {
          name: 'manage_final',
          path: '/bosemexam/manage_final',
          meta: {
            title: 'Final Results',
          },
          component: () => import('./views/admin/bosemexam/final'),
        },
        {
          name: 'classfinalresultreport',
          path: '/bosemexam/classfinalresultreport/:classId/:className/:sessionId',
          meta: {
            title: 'Final Result Report',
          },
          component: () => import('./views/admin/bosemexam/finalreport'),
        },

        // Exam
        {
          name: 'examtypes',
          path: '/exam/types',
          meta: {
            title: 'Exam Types',
          },
          component: () => import('./views/admin/exam/types'),
        },
        {
          name: 'schoolexams',
          path: '/exam/schoolexams',
          meta: {
            title: 'School Exams',
          },
          component: () => import('./views/admin/exam/schoolexams'),
        },
        {
          name: 'manageexam',
          path: '/exam/manage',
          meta: {
            title: 'Manage Exams',
          },
          component: () => import('./views/admin/exam/setup'),
        },
        {
          name: 'exammanage',
          path: '/exam/manage/:id',
          meta: {
            title: 'Exam Management',
          },
          component: () => import('./views/admin/exam/manage'),
        },
        {
          name: 'examadmitcard',
          path: '/exam/admitcards/:id',
          meta: {
            title: 'Exam Admitcards',
          },
          component: () => import('./views/admin/exam/admitcard'),
        },
        {
          name: 'examgrades',
          path: '/exam/grades',
          meta: {
            title: 'Exam Grades',
          },
          component: () => import('./views/admin/exam/grades'),
        },
        {
          name: 'classexamgrades',
          path: '/exam/class-grades',
          meta: {
            title: 'Class Exam Grades',
          },
          component: () => import('./views/admin/exam/classgrades'),
        },
        // manage final
        {
          name: 'managefinal',
          path: '/exam/managefinal',
          meta: {
            title: 'Final Results',
          },
          component: () => import('./views/admin/exam/final'),
        },
        {
          name: 'finalresultreport',
          path: '/exam/finalresultreport/:classId/:className/:sessionId',
          meta: {
            title: 'Final Result Report',
          },
          component: () => import('./views/admin/exam/finalreport'),
        },

        // my custom bethel test final report
        {
          name: 'finalResultReport',
          path: '/bosemexam/finalResultReport/:classId/:className/:sessionId',
          meta: {
            title: 'Final Result Report',
          },
          component: () => import('./views/admin/bosemexam/finalreport/finalreport'),
        },
        // exam report
        {
          name: 'reportcard',
          path: '/exam/reportcard',
          meta: {
            title: 'Report Card',
          },
          component: () => import('./views/admin/exam/reportcard/index'),
        },

        {
          name: 'internalmarks',
          path: '/exam/internal_marks',
          meta: {
            title: 'Internal Marks',
          },
          component: () => import('./views/admin/exam/internal'),
        },
        // exam setting
        {
          name: 'examsetting',
          path: '/exam/examsetting',
          meta: {
            title: 'Exam Setting',
          },
          component: () => import('./views/admin/exam/examsetting'),
        },
        // online exam result
        {
          name: 'onlineexamresult',
          path: '/online-exam/result/:examId/:statusId',
          meta: {
            title: 'Online-exam Result',
          },
          component: () => import('./views/admin/online-exam/result'),
        },
        // online-exam types
        {
          name: 'onlineexamtypes',
          path: '/online-exam/types',
          meta: {
            title: 'Exam Types',
          },
          component: () => import('./views/admin/online-exam/types'),
        },

        // Online exam
        {
          name: 'manageonlineexam',
          path: '/online-exams',
          meta: {
            title: 'Manage Online Exam',
          },
          component: () => import('./views/admin/online-exam/exam'),
        },
        {
          name: 'onlineexamquestions',
          path: '/online-exams/questions/:examType/:examId/:classId/:questionWiseMark',
          meta: {
            title: 'Online Exam Questions',
          },
          component: () => import('./views/admin/online-exam/question'),
        },
        {
          name: 'examinstructions',
          path: '/online-exam/instructions',
          meta: {
            title: 'Exam Instructions',
          },
          component: () => import('./views/admin/online-exam/instruction'),
        },

        // Settings
        {
          name: 'institutesettings',
          path: '/settings/institute',
          meta: {
            title: 'Settings',
          },
          component: () => import('./views/admin/settings/school'),
        },
        {
          name: 'profilesettings',
          path: '/settings/profile',
          meta: {
            title: 'Profile',
          },
          component: () => import('./views/admin/settings/profile'),
        },
        {
          name: 'manageusers',
          path: '/settings/users',
          meta: {
            title: 'Users',
          },
          component: () => import('./views/admin/settings/user'),
        },
        {
          name: 'manageroles',
          path: '/settings/roles',
          meta: {
            title: 'Manage Roles',
          },
          component: () => import('./views/admin/settings/roles'),
        },
        {
          name: 'modules',
          path: '/settings/modules',
          meta: {
            title: 'Modules',
          },
          component: () => import('./views/admin/settings/modules'),
        },

        // Back Office
        {
          name: 'calendar',
          path: '/backoffice/calendar',
          meta: {
            title: 'Calendar',
          },
          component: () => import('./views/admin/backoffice/calendar'),
        },
        // Attendance
        {
          name: 'studentattendance',
          path: '/backoffice/attendance',
          meta: {
            title: 'Student Attendance',
          },
          component: () => import('./views/admin/backoffice/attendance'),
        },
        // Leave Requests
        {
          name: 'studentleaverequest',
          path: '/backoffice/leaverequests',
          meta: {
            title: 'Leave Request',
          },
          component: () => import('./views/admin/backoffice/leaverequest'),
        },
        {
          name: 'studentidcards',
          path: '/backoffice/idcards',
          meta: {
            title: 'ID Card',
          },
          component: () => import('./views/admin/backoffice/idcard'),
        },
        // Manage Fees
        {
          name: 'managefees',
          path: '/backoffice/managefees',
          meta: {
            title: 'Manage Fees',
          },
          component: () => import('./views/admin/backoffice/managefee'),
        },
        // Pay Fees
        {
          name: 'feesummary',
          path: '/backoffice/feesummary',
          meta: {
            title: 'Fee Summary',
          },
          component: () => import('./views/admin/backoffice/feesummary'),
        },
        // Pay Fees
        {
          name: 'payfees',
          path: '/backoffice/payfees',
          meta: {
            title: 'Pay Fees',
          },
          component: () => import('./views/admin/backoffice/feepayment'),
        },
        // Admission Forms
        {
          name: 'applicationforms',
          path: '/backoffice/application-forms',
          meta: {
            title: 'Application Forms',
          },
          component: () => import('./views/admin/backoffice/applicationform'),
        },
        // Subject Group
        {
          name: 'subjectgroup',
          path: '/backoffice/subject-group',
          meta: {
            title: 'Subjects Group',
          },
          component: () => import('./views/admin/backoffice/subject-group'),
        },
        // fee-export
        {
          name: 'feeexport',
          path: '/backoffice/fee-export',
          meta: {
            title: 'Fee Export',
          },
          component: () => import('./views/admin/backoffice/feeexport'),
        },
        {
          name: 'ordersbills',
          path: '/account/orders',
          meta: {
            title: 'Orders Bill',
          },
          component: () => import('./views/account/order'),
        },
        {
          name: 'ordersreports',
          path: '/inventory/reports',
          meta: {
            title: 'Orders Report',
          },
          component: () => import('./views/inventory/reports'),
        },
        {
          name: 'accountdownloads',
          path: '/account/exports',
          meta: {
            title: 'Account Exports',
          },
          component: () => import('./views/account/export'),
        },
        {
          name: 'applicants',
          path: '/backoffice/applicants/:formId',
          meta: {
            title: 'Application Forms',
          },
          component: () => import('./views/admin/backoffice/applicant'),
        },
        {
          name: 'parentregistration',
          path: '/backoffice/parentregistration/',
          meta: {
            title: 'Parent Registration',
          },
          component: () => import('./views/admin/backoffice/parentregistration'),
        },
        {
          name: 'certificategeneration',
          path: '/backoffice/certificategeneration/',
          meta: {
            title: 'Certificate Generation',
          },
          component: () => import('./views/admin/backoffice/certificategeneration'),
        },
      ],
    },
    // Student Pages
    {
      path: '/student',
      redirect: '/student/dashboard',
      component: AppLayout,
      meta: { authRequired: true, roles: ['normal'], hidden: false },
      children: [
        // Dashboards
        {
          name: 'studentdashboard',
          path: `/student/dashboard`,
          meta: {
            title: 'Student Dashboard',
          },
          component: () => import('./views/student/dashboard'),
        },
        {
          name: 'onlineexam',
          path: `/student/online-exams`,
          meta: {
            title: 'Online exams',
          },
          component: () => import('./views/student/online-exam'),
        },
      ],
    },
    // Student Auth Pages
    {
      path: '/login',
      component: AuthLayout,
      redirect: '/login',
      children: [
        {
          name: 'studentlogin',
          path: '/login',
          meta: {
            title: 'Student Login',
          },
          component: () => import('./views/system/student-login'),
        },

      ],
    },
    // System Pages
    {
      path: '/system',
      component: AuthLayout,
      redirect: '/system/login',
      children: [
        {
          name: 'login',
          path: '/system/login',
          meta: {
            title: 'Login',
          },
          component: () => import('./views/system/login'),
        },
        {
          name: 'forgotpassword',
          path: '/system/forgot-password',
          meta: {
            title: 'Forgot Password',
          },
          component: () => import('./views/system/forgot-password'),
        },
        {
          name: 'resetlinksent',
          path: '/system/reset-link-sent',
          meta: {
            title: 'Reset Link Sent',
          },
          component: () => import('./views/system/reset-link-sent'),
        },
        {
          name: 'resetpassword',
          path: '/system/reset-password',
          meta: {
            title: 'Reset Password',
          },
          component: () => import('./views/system/reset-password'),
        },
        {
          path: '/system/register',
          meta: {
            title: 'Register',
          },
          component: () => import('./views/system/register'),
        },
        {
          path: '/system/lockscreen',
          meta: {
            title: 'Lockscreen',
          },
          component: () => import('./views/system/lockscreen'),
        },
        {
          name: '404',
          path: '/system/404',
          meta: {
            title: 'Error 404',
          },
          component: () => import('./views/system/404'),
        },
        {
          path: '/system/500',
          meta: {
            title: 'Error 500',
          },
          component: () => import('./views/system/500'),
        },
      ],
    },
    // School Public Pages
    {
      path: '/school',
      component: PublicLayout,
      redirect: '/school/pay-fees',
      children: [
        {
          name: 'publicpayfees',
          path: '/school/pay-fees',
          meta: {
            title: 'Pay Fees',
          },
          component: () => import('./views/school/feepayment'),
        },
        {
          name: 'pausepayfees',
          path: '/school/pay-fees/pause',
          meta: {
            title: 'Pay Fees',
          },
          component: () => import('./views/school/feepayment/pausefeepayment'),
        },
        {
          name: 'onlineapplications',
          path: '/school/online-applications',
          meta: {
            title: 'Online Applications',
          },
          component: () => import('./views/school/onlineapplication/list'),
        },
        {
          name: 'onlineapplication',
          path: '/school/online-application/:formId',
          meta: {
            title: 'Online Application Form',
          },
          component: () => import('./views/school/onlineapplication/form'),
        },
        // new online common form
        {
          name: 'onlinecommonapplication',
          path: '/school/online-application/commonForm/:formId',
          meta: {
            title: 'Online Application Form',
          },
          component: () => import('./views/school/onlineapplication/form/commonForm'),
        },
        {
          name: 'publicptermsandcondition',
          path: '/school/terms-conditions',
          meta: {
            title: 'T & C',
          },
          component: () => import('./views/term_and_condition'),
        },
        {
          name: 'publicprivacypolicy',
          path: '/school/privacy-policy',
          meta: {
            title: 'Privacy Policy',
          },
          component: () => import('./views/privacy_policy'),
        },
      ],
    },
    // Inventory
    {
      path: '/inventory',
      redirect: '/inventory',
      component: AppLayout,
      meta: { authRequired: true, roles: ['admin', 'supervisor', 'staff', 'teacher'], hidden: true },
      children: [
        {
          name: 'inventorydashboard',
          path: '/inventory/dashboard',
          meta: {
            title: 'Inventory Dashboard',
          },
          component: () => import('./views/inventory/dashboard/index'),
        },
        {
          name: 'categories',
          path: '/inventory/categories',
          meta: {
            title: 'Categories',
          },
          component: () => import('./views/inventory/category/index'),
        },
        {
          name: 'products',
          path: '/inventory/products',
          meta: {
            title: 'Products',
          },
          component: () => import('./views/inventory/product'),
        },
        {
          name: 'orders',
          path: '/inventory/orders',
          meta: {
            title: 'Orders',
          },
          component: () => import('./views/inventory/order'),
        },
        {
          name: 'bundledproducts',
          path: '/inventory/bundled_products',
          meta: {
            title: 'Bundled Products',
          },
          component: () => import('./views/inventory/bundled_products'),
        },
        {
          name: 'producttransactions',
          path: '/inventory/product_transactions',
          meta: {
            title: 'Product Transactions',
          },
          component: () => import('./views/inventory/transactions'),
        },
        {
          name: 'bundledtransactions',
          path: '/inventory/bundled_transactions',
          meta: {
            title: 'Bundled Transactions',
          },
          component: () => import('./views/inventory/bundled_product_transaction'),
        },
        {
          name: 'reports',
          path: '/inventory/reports',
          meta: {
            title: 'Reports',
          },
          component: () => import('./views/inventory/reports'),
        },
      ],
    },
    // Inventory
    // Hostel
    {
      path: '/hostel',
      redirect: '/hostel',
      component: AppLayout,
      meta: { authRequired: true, roles: ['admin', 'supervisor', 'staff', 'teacher'], hidden: true },
      children: [
        {
          name: 'hostels',
          path: '/hostel/add',
          meta: {
            title: 'Hostels',
          },
          component: () => import('./views/hostel/manage/hostel'),
        },
        {
          name: 'blocks',
          path: '/hostel/blocks',
          meta: {
            title: 'Blocks',
          },
          component: () => import('./views/hostel/manage/hostel-block'),
        },
        {
          name: 'facilities',
          path: '/hostel/facilities',
          meta: {
            title: 'Facilities',
          },
          component: () => import('./views/hostel/manage/hostel-facility'),
        },
        {
          name: 'rooms',
          path: '/hostel/rooms',
          meta: {
            title: 'Rooms',
          },
          component: () => import('./views/hostel/manage/hostel-room'),
        },
        {
          name: 'enrollments',
          path: '/hostel/enrollments',
          meta: {
            title: 'Enrollments',
          },
          component: () => import('./views/hostel/manage/hostel-enrollment'),
        },
        {
          name: 'pocketmoney',
          path: '/hostel/pocket-money',
          meta: {
            title: 'Pocket Money',
          },
          component: () => import('./views/hostel/manage/pocket-money'),
        },
      ],
    },
    {
      path: '/support',
      redirect: '/support',
      component: AppLayout,
      meta: { authRequired: true, roles: ['admin', 'supervisor', 'staff', 'teacher'], hidden: true },
      children: [
        {
          name: 'requests',
          path: '/support/requests',
          meta: {
            title: 'Requests',
          },
          component: () => import('./views/support/requests/index'),
        },
      ],
    },
    {
      path: '/library',
      redirect: '/library',
      component: AppLayout,
      meta: { authRequired: true, roles: ['admin', 'supervisor', 'staff', 'teacher'], hidden: true },
      children: [
        {
          name: 'books',
          path: '/library/books',
          meta: {
            title: 'Books',
          },
          component: () => import('./views/library/books/index'),
        },
        {
          name: 'category',
          path: '/library/category',
          meta: {
            title: 'Categories',
          },
          component: () => import('./views/library/category/index'),
        },
        {
          name: 'issue',
          path: '/library/issue',
          meta: {
            title: 'Issue/Return',
          },
          component: () => import('./views/library/loan/index'),
        },
      ],
    },
    {
      path: '/transport',
      redirect: '/transport',
      component: AppLayout,
      meta: { authRequired: true, roles: ['admin', 'supervisor', 'staff', 'teacher'], hidden: true },
      children: [
        {
          name: 'vehicles',
          path: '/transport/vehicle',
          meta: {
            title: 'Vehicles',
          },
          component: () => import('./views/transport/vehicle/index'),
        },
        {
          name: 'routes',
          path: '/transport/route',
          meta: {
            title: 'Routes',
          },
          component: () => import('./views/transport/route/index'),
        },
        // {
        //   name: 'drivers',
        //   path: '/transport/driver',
        //   meta: {
        //     title: 'Drivers',
        //   },
        //   component: () => import('./views/transport/driver/index'),
        // },
      ],
    },
    // Redirect to 404
    {
      path: '*',
      redirect: 'system/404',
      hidden: true,
    },
  ],
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.authRequired)) {
    if (!store.state.user.token) {
      next({
        path: '/system/login',
        // query: { redirect: to.fullPath },
      })
    } else {
      getUserRole().then(userRole => {
        if (!to.matched.some(record => {
          if (record.meta.roles) {
            // return record.meta.role === userRole
            return record.meta.roles.includes(userRole)
          }
          return false
        })) {
          // next({
          //   path: userRole + '/dashboard',
          // })
          if (userRole === 'superadmin') {
            next({
              path: 'superadmin/dashboard',
            })
          }
          if (['admin', 'supervisor', 'teacher', 'staff'].includes(userRole)) {
            next({
              path: 'dashboard',
            })
          }
          if (['normal'].includes(userRole)) {
            next({
              path: 'student/dashboard',
            })
          }
        }
      }).catch(error => console.log(error))
      next()
    }
  } else {
    next()
  }
})

export default router
